import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  payoutDetails: [],
  status: 'idle', 
  error: null,
  paginationDetail: {
    totalRecords: 0,
    totalDocs: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
  },
};


export const fetchPayoutDetails = createAsyncThunk(
  'payout/fetchPayoutDetails',
  async (params, { rejectWithValue }) => {
    const { startDate, endDate, search = "", page, limit } = params || {}; 

    const token = localStorage.getItem('vedhvidhi-admin-token');
    if (!token) {
      return rejectWithValue('Authorization token not found');
    }

    let url = `${process.env.REACT_APP_BASEURL}/admin/payoutSummary`;
    const queryParams = [];
    
    if (page !== undefined && limit !== undefined) {
      queryParams.push(`page=${page}`);
      queryParams.push(`limit=${limit}`);
    }
    
    if (startDate && endDate) {
      queryParams.push(`startDate=${startDate}`);
      queryParams.push(`endDate=${endDate}`);
    }
    if (search) {
      queryParams.push(`search=${encodeURIComponent(search)}`);
    }
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch payout details');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Slice
const payoutSlice = createSlice({
  name: 'payout',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayoutDetails.pending, (state) => {
        state.status = 'loading';
        state.error = null; 
      })
      .addCase(fetchPayoutDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.payoutDetails = action.payload.data || [];
        // Backward compatibility: use paginationDetail from response or default values
        state.paginationDetail = action.payload.paginationDetail || {
          totalRecords: action.payload.totalRecords || action.payload.totalDocs || (action.payload.data?.length || 0),
          totalDocs: action.payload.totalDocs || action.payload.totalRecords || (action.payload.data?.length || 0),
          currentPage: action.payload.currentPage || action.payload.page || 1,
          perPage: action.payload.perPage || action.payload.limit || 10,
          totalPages: action.payload.totalPages || Math.ceil((action.payload.totalRecords || action.payload.totalDocs || 0) / (action.payload.perPage || action.payload.limit || 10)),
        };
      })
      .addCase(fetchPayoutDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload; 
      });
  },
});

export default payoutSlice.reducer;
